import { TableFilterConfig } from '@/components/data-table/filters-v2';
import i18n from '@/core/i18n';
import { DEFAULT_PAGE_SIZE_CLIENTS_SHORT_ENTITIES } from '@/lib/constants/pagination';
import { EntityAvatar, getClientStatusOptions } from '@/modules/common';
import { getShortTeamMembers } from '@/modules/team/api/team.api';
import { mapShortTeamMembersToManagers } from '@/modules/team/mappers/team-member-short.mapper';
import { NON_ARCHIVED_TEAM_MEMBER_STATUSES } from '@/modules/team/types/dto/find-short-team-members.request';
import { FilterOption } from '@/types/filters';

import { ClientStatus } from '../types';
import {
  CLIENTS_FILTER_KEY_MANAGER,
  CLIENTS_FILTER_KEY_SEARCH,
  CLIENTS_FILTER_KEY_STATUS,
} from './clients-filter-keys';

export const getClientsTableFiltersConfig = (): TableFilterConfig[] => [
  {
    type: 'search',
    name: CLIENTS_FILTER_KEY_SEARCH,
    label: i18n.t('common:search'),
    placeholder: i18n.t('authenticated.clients:searchPlaceholder'),
  },
  {
    type: 'dynamic-autocomplete',
    name: CLIENTS_FILTER_KEY_MANAGER,
    withSearch: true,
    label: i18n.t('authenticated.clients:filters.manager'),
    loadOptions: async params => {
      const response = await getShortTeamMembers({
        filter: {
          isManager: true,
          searchString: params.searchString,
          statuses: NON_ARCHIVED_TEAM_MEMBER_STATUSES,
        },
        pagination: {
          cursor: params.cursor,
          pageSize: params.pageSize ?? DEFAULT_PAGE_SIZE_CLIENTS_SHORT_ENTITIES,
        },
      });

      const managers = mapShortTeamMembersToManagers(
        response.items.map(item => ({
          id: Number(item.id),
          name: item.name,
          email: item.secondaryText ?? '',
          profileImageUrl: item.avatarLink ?? null,
          status: '',
          connectedIntegrations: [],
        }))
      );

      return {
        items: managers,
        pagination: response.pagination,
      };
    },
    renderLabel: (value: string, option: FilterOption) => (
      <div className="flex items-center gap-2">
        <EntityAvatar image={option.avatar} name={value} size="xs" shape="circle" />
        <span className="text-sm">{value}</span>
      </div>
    ),
  },
  {
    type: 'autocomplete',
    name: CLIENTS_FILTER_KEY_STATUS,
    label: i18n.t('authenticated.clients:filters.status'),
    options: getClientStatusOptions([ClientStatus.Active, ClientStatus.Archived]),
  },
];
